import "./GameSelect.css";

export default function GameTile({ game, onSelect }) {
  return (
    <button
      className="game-tile"
      onClick={() => onSelect(game)}
      style={{ "--game-image": `url("/games/${game.id}-tile.webp")` }}
      aria-label={`Open ${game.label}`}
    >
      <div className="game-tile__overlay" />

      <div className="game-tile__content">
        <span className="game-tile__description">
          {game.description}
        </span>
        <h2 className="game-tile__title">
          {game.label}
        </h2>
      </div>
    </button>
  );
}